import * as Yup from "yup";

export function initialValues() {
  //funcion para inicializar los valores de los campos
  return {
    email: "",
    password: "",
  };
}

export function validationSchema(t) {
  //funcion para validar los campos
  return Yup.object({
    email: Yup.string()
      .email(t("validation.emailInvalid"))
      .required(t("validation.required")),
    password: Yup.string().required(t("validation.required")),
  });
}
